module.exports = __webpack_public_path__ + "static/media/jacare.7d1c2257.jpeg";